import { FeatureLogger } from "../utils/feature-logger";
const name = "ez-commerce";
const logger = new FeatureLogger(name);

import { loadScript } from "../utils/load-script";
import { captureErrorAsync } from "../utils/capture-error-async";
import { globalVarReady, domReady } from "../utils/ready";
import { loadStylesheet } from "../utils/load-stylesheet";

declare global {
  interface Window {
    EzCommerceGenerator?: (variables: {
      shopifyDomain?: string;
      storefrontAccessToken?: string;
      universalRetailerId: string;
    }) => () => void;
  }
}

interface Variables {
  shopifyDomain?: string;
  storefrontAccessToken?: string;
}

export async function configEzCommerce(
  variables: Variables,
  context: FeatureContext
): Promise<void> {
  await domReady();
  const ezCommerceGenerator = await globalVarReady("EzCommerceGenerator");
  const build = ezCommerceGenerator({
    ...variables,
    universalRetailerId: context.universalRetailerId,
  });
  build();
}

async function installEzCommerceScript(
  variables: Variables,
  context: FeatureContext
) {
  const srcScript = `https://adhawk-marketplace-assets.s3-us-west-1.amazonaws.com/index-factory.js`;
  const srcStyle = `https://adhawk-marketplace-assets.s3-us-west-1.amazonaws.com/index.css`;

  try {
    loadStylesheet(srcStyle);
    await loadScript(srcScript);
    configEzCommerce(variables, context);

    logger.debug(`Successfully installed Ez Commerce script from ${srcScript}`);
  } catch (e) {
    logger.error(`Could not install Ez Commerce script from ${srcScript}`);
    captureErrorAsync(e);
  }
}

export async function install(
  variables: Variables,
  context: FeatureContext
): Promise<void> {
  installEzCommerceScript(variables, context);
}
